export default __webpack_public_path__ + "static/media/woman_using_small.a28f7a7a.png";